module.exports = __webpack_public_path__ + "img/ios_1@2x.ca6b2ec2.png";